<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"> {{ $t('ITEM.ADD') }} {{ $t('USERS.ITEM') }} </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <user-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UserForm from '@/modules/users/components/forms/UserForm';
import errors from '@/modules/_global/mixins/errors';
import { mapActions } from 'vuex';
import { onceRequest } from '@/modules/_global/utils/common';

export default {
  name: 'CreateUser',

  components: {
    UserForm
  },

  mixins: [errors],

  data() {
    return {
      valid: true,
      form: {}
    };
  },

  methods: {
    ...mapActions('person', ['store']),

    cancel() {
      this.$emit('cancel');
    },

    create: onceRequest(function create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      let data = {
        person: this.form.person,
        user: this.form.user,
        work_profile: this.form.profile,
        roles: Object.assign({}, this.form.role),
        additional_permissions: Object.assign(
          {},
          this.form.additional_permission
        )
      };

      return this.store(data)
        .then(({ data }) => {
          this.$emit('created', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    })
  }
};
</script>

<style scoped></style>
